var _path;
import * as React from "react";
function SvgChevronBoldDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.755 29.195L4.515 14.953a1.759 1.759 0 010-2.487l1.66-1.661a1.759 1.759 0 012.485-.003l11.339 11.287 11.34-11.286a1.758 1.758 0 012.484.003l1.661 1.66a1.76 1.76 0 010 2.488L21.242 29.195a1.76 1.76 0 01-2.487 0z"
  })));
}
export default SvgChevronBoldDown;